import PropTypes from 'prop-types';
import React, {PureComponent} from 'react';
import get from 'lodash/get';
import omit from 'lodash/omit';
import cn from 'classnames';
import css from './css.css';

import TargetRow from './TargetRow';
import StyledCol from "~/components/TargetGrid/StyledCol";
import { Grid, Row } from '~/native-ui';
import { extractSpacingProps } from '~/native-ui';

export default class TargetGrid extends PureComponent {
    static propTypes = {
        rows: PropTypes.array.isRequired,
        elements: PropTypes.object.isRequired
    };

    levelClassName = (level) => {
        return level ? cn(css[`level${level}`], css.level) : null;
    };

    renderCols = (cols, defaultStyle) => {
        return cols.map((col, i) => {
            col = {...col, ...defaultStyle};

            return (
                <StyledCol {...omit(col, ['rows', 'style'])} key={i} >
                    {this.renderRows(col.rows, col.style)}
                </StyledCol>
            );
        });
    };

    renderRows = (rows, defaultStyle) => {
        let { elements } = this.props;

        return rows.reduce((theRows, row, i) => {
            row = { ...defaultStyle, ...row };
            let { name, target, level, cols, className, style, toggle, ...other } = row;

            // if name is set we have a target row, only render target rows that have elements, omit the others
            let groupElements = get(elements, name, []),
                rendered = null,
                levelClassName = this.levelClassName(level);

            if(name) {
                if(groupElements.length && (!target || get(elements, `${target}.length`, 0)) ) {
                    rendered = (<TargetRow
                        {...other}
                        level={ level }
                        elements={groupElements}
                        className={cn(css.row, css.targetRow, levelClassName)}
                        columnStyle={style}
                        key={name}
                    />);
                }
            } else {
                rendered = (
                    <Row key={`row-${i}`} level={ level } className={cn(css.row, className, levelClassName)}>
                        {this.renderCols(cols, style)}
                    </Row>
                );
            }

            // rendered = this.wrapLevelled(rendered, row);

            theRows.push(rendered);

            return theRows;
        }, []);
    };

    render() {
        let [spacingProps, { rows, style }] = extractSpacingProps(this.props);
        
        return (
            <Grid { ...spacingProps }>
                {this.renderRows(rows, style)}
            </Grid>
        );
    }
}